import { useState } from 'react';

function PythonModule() {
  const [openModule, setOpenModule] = useState(null);

  const toggleModule = (index) => {
    setOpenModule(openModule === index ? null : index);
  };

  const modules = [
    {
      title: "Module 1: Introduction to Python Programming",
      content: [
        "What is Python? An overview of Python's features.",
        "History of Python: Evolution and key milestones.",
        "Setting up Python environment: Installing Python and setting up an IDE.",
        "Basic Syntax and Structure in Python."
      ]
    },
    {
      title: "Module 2: Variables and Data Types",
      content: [
        "Understanding Variables in Python: Declaring and assigning values.",
        "Common Data Types: Strings, Integers, Floats, and Booleans.",
        "Type Conversion: How to convert between data types.",
        "Working with Lists, Tuples, and Dictionaries."
      ]
    },
    {
      title: "Module 3: Control Flow and Functions",
      content: [
        "Conditional Statements: Using if, elif, else.",
        "Loops: for and while loops in Python.",
        "Functions: Defining and calling functions, passing arguments.",
        "Scope and Lifetime of variables in functions."
      ]
    },
    {
      title: "Module 4: Object-Oriented Programming",
      content: [
        "Classes and Objects: Understanding OOP concepts in Python.",
        "Attributes and Methods: Defining and using them.",
        "Inheritance: How inheritance works in Python.",
        "Polymorphism and Encapsulation."
      ]
    },
    {
      title: "Module 5: Exception Handling",
      content: [
        "What is Exception Handling?",
        "Try, Except, Finally blocks in Python.",
        "Handling Multiple Exceptions.",
        "Custom Exceptions: Creating and raising your own exceptions."
      ]
    },
    {
      title: "Module 6: Python Libraries and Modules",
      content: [
        "Working with Python Standard Library.",
        "Popular Libraries in Python: NumPy, Pandas, Matplotlib.",
        "Installing and Managing External Libraries using pip.",
        "How to create and import custom modules."
      ]
    },
    {
      title: "Module 7: File Handling",
      content: [
        "Reading from and Writing to Files.",
        "File Modes: r, w, a, etc.",
        "Handling File Paths and Directories.",
        "Working with CSV and JSON files."
      ]
    },
    {
      title: "Module 8: Data Structures in Python",
      content: [
        "Understanding Lists, Tuples, Sets, and Dictionaries.",
        "Working with Stacks, Queues, and Linked Lists.",
        "Exploring Nested Data Structures.",
        "When to use each data structure."
      ]
    },
    {
      title: "Module 9: Python for Web Development",
      content: [
        "Introduction to Web Development with Python.",
        "Working with Flask and Django.",
        "Building a simple web application in Flask.",
        "Connecting Python to Databases (SQLite, MySQL)."
      ]
    },
    {
      title: "Module 10: Python for Data Science and Machine Learning",
      content: [
        "Using Python for Data Analysis: Pandas and NumPy.",
        "Data Visualization with Matplotlib and Seaborn.",
        "Introduction to Machine Learning: Libraries and Tools.",
        "Building a basic machine learning model using Scikit-Learn."
      ]
    },
    {
      title: "Module 11: Advanced Python Concepts",
      content: [
        "Decorators and Generators in Python.",
        "Lambda Functions and List Comprehensions.",
        "Multithreading and Multiprocessing.",
        "Understanding Python’s Global Interpreter Lock (GIL)."
      ]
    }
  ];

  return (
    <div className="container-fluid">
      <div className="container">
        <h1 className="text-center py-5">Python Programming Course Curriculum</h1>
        <div className="row justify-content-center">
          {modules.map((module, index) => (
            <div
              key={index}
              className="col-12 col-md-5 mb-3 d-flex flex-column align-items-center"
              style={{ marginBottom: '10px' }}
            >
              {/* Accordion Heading */}
              <div
                className="w-100 p-3 d-flex justify-content-between align-items-center"
                style={{
                  backgroundColor: '#f8f9fa',
                  border: '1px solid #ddd',
                  cursor: 'pointer'
                }}
                onClick={() => toggleModule(index)}
              >
                <h5 className="m-0">{module.title}</h5>
                <span
                  style={{
                    fontSize: '18px',
                    transform: openModule === index ? 'rotate(180deg)' : 'rotate(0deg)',
                    transition: 'transform 0.3s'
                  }}
                >
                  ▼
                </span>
              </div>

              {/* Accordion Content */}
              {openModule === index && (
                <div
                  className="w-100 p-3"
                  style={{
                    border: '1px solid #ddd',
                    borderTop: 'none',
                    backgroundColor: '#ffffff'
                  }}
                >
                  {module.content.map((item, itemIndex) => (
                    <div
                      key={itemIndex}
                      className="d-flex align-items-center mb-2"
                      style={{
                        border: '1px solid #ddd',
                        borderRadius: '4px',
                        padding: '8px',
                        backgroundColor: '#fdfdfd'
                      }}
                    >
                      <span style={{ color: '#007bff', marginRight: '8px' }}>➤</span>
                      <p className="m-0" style={{ fontSize: '14px', color: '#333' }}>
                        {item}
                      </p>
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default PythonModule;
